<div class="ap-filter">
	<input type="checkbox" id="switch" (change)="onChange($event)"  [checked]="control.options" />
	<label for="switch">
		<span>SHOW IN-STOCK ONLY</span>
	</label>
</div>
